export default {
      id: "icon--youtube-usage",
      viewBox: "0 0 19.91 14",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--youtube-usage",
      toString: function () {
        return this.url;
      }
    }